import { ListItem, ListItemButton, Typography, Divider } from '@mui/material'
import { TrackingDto } from '@/generated/Messages/Basic_pb'
import { OmitDeepMessageFields } from '@/types/OmitDeepMessageFields'
import { SeleniumProperty } from '@/types/seleniumProperty'

export const TrackingListItem: React.FC<
    Partial<
        Record<
            | keyof OmitDeepMessageFields<TrackingDto>
            | 'duration'
            | 'mostRecentlyModifiedByService',
            React.ReactNode
        >
    > &
        SeleniumProperty & {
            onClick?: React.MouseEventHandler
            displayColor?: string
            mostRecentlyModifiedByService?: boolean
        }
> = ({
    startedAt,
    endedAt,
    duration,
    projectName,
    publicDescription,
    internalDescription,
    displayColor,
    mostRecentlyModifiedByService,
    'data-selenium': dataSelenium,
    onClick,
}) => (
    <ListItem
        disablePadding={true}
        sx={[
            theme => ({
                borderInlineStart: `1px solid ${displayColor ?? theme.vars.palette.grey[600]}`,
            }),
            theme =>
                theme.applyStyles('dark', {
                    backgroundColor:
                        mostRecentlyModifiedByService ?
                            `rgb(from ${theme.vars.palette.warning.light} r g b / 0.1)`
                        :   undefined,
                }),
            theme =>
                theme.applyStyles('light', {
                    backgroundColor:
                        mostRecentlyModifiedByService ?
                            `rgb(from ${theme.vars.palette.warning.dark} r g b / 0.1)`
                        :   undefined,
                }),
        ]}
    >
        <ListItemButton
            sx={{
                columnGap: 2,
                rowGap: 1,

                display: 'grid',
                gridTemplateAreas: [
                    "'start_end duration'",
                    "'project project'",
                    "'description description'",
                ].join('\n'),
                gridTemplateColumns: 'auto 1fr',
            }}
            onClick={onClick}
            data-selenium={dataSelenium}
        >
            <Typography
                variant={'subtitle1'}
                color={'textDisabled'}
                style={{ gridArea: 'start_end' }}
            >
                {startedAt} {' - '} {endedAt}
            </Typography>

            <Typography
                variant={'subtitle1'}
                color={'textDisabled'}
                style={{ gridArea: 'duration' }}
            >
                {duration}
            </Typography>

            <Typography style={{ gridArea: 'project' }}>
                {projectName}
            </Typography>

            <div style={{ gridArea: 'description' }}>
                {publicDescription && (
                    <Typography>{publicDescription}</Typography>
                )}

                {publicDescription && internalDescription && (
                    <Divider sx={{ marginTop: 1, marginBottom: 1 }} />
                )}

                {internalDescription && (
                    <Typography>{internalDescription}</Typography>
                )}
            </div>
        </ListItemButton>
    </ListItem>
)
